document.addEventListener('DOMContentLoaded', () => {
 
  
  document.querySelectorAll('.menu-link').forEach(link => {
  link.addEventListener('click', function (e) {
    const parentLi = this.parentElement;
    const submenu = parentLi.querySelector('ul');

    if (submenu) {
      e.preventDefault();
      this.classList.toggle('open');
      submenu.classList.toggle('open');
    }
  });
});

 
  
  // Drawer open toggle
  const drawerToggle = document.querySelector('.drawer-toggle');
  const drawerClose = document.querySelector('.drawer-close');
  const navDrawer = document.getElementById('NavDrawer');

  if (drawerToggle && navDrawer) {
    drawerToggle.addEventListener('click', () => {
      navDrawer.classList.add('open');
      document.body.classList.add('menu-open');
    });
  }

  if (drawerClose && navDrawer) {
    drawerClose.addEventListener('click', () => {
      navDrawer.classList.remove('open');
      document.body.classList.remove('menu-open');
    });
  }

 // Hide scrollbar on drawer content but allow scrolling
const drawerContent = document.querySelector('#NavDrawer');
if (drawerContent) {
  // Apply CSS via JS
  drawerContent.style.overflowY = 'auto';
  drawerContent.style.scrollbarWidth = 'none'; // Firefox
  drawerContent.style.msOverflowStyle = 'none'; // IE/Edge

  // Inject WebKit scrollbar hiding
  const style = document.createElement('style');
  style.textContent = `
    #NavDrawer::-webkit-scrollbar {
      display: none;
    }
  `;
  document.head.appendChild(style);
}
  
  // Utility: Close sibling menu items
  function closeSiblings(li) {
    li.parentElement.querySelectorAll('.open').forEach(sibling => {
      if (sibling !== li) {
        sibling.classList.remove('open');
        sibling.style.height = null;
        sibling.style.transition = '';
      }
    });
  }

  // Submenu toggle logic with height animation
  document.querySelectorAll('.mcd-menu li').forEach(li => {
    const submenu = li.querySelector('ul');
    const link = li.querySelector('a');

    if (submenu && link) {
      li.classList.add('has-submenu');

      link.addEventListener('click', e => {
        // Only toggle on dummy links to prevent navigation
        if (link.getAttribute('href') === '#' || link.getAttribute('href') === '') {
          e.preventDefault();

          const isOpen = li.classList.contains('open');
          

          if (isOpen) {
            // Close submenu
            li.classList.remove('open');
            li.style.height = li.scrollHeight + 'px'; // start from full height

            requestAnimationFrame(() => {
              li.style.transition = 'height 0.3s ease';
              li.style.height = '10px'; // closed height
            });

            li.addEventListener('transitionend', function handler() {
              li.style.height = '';
              li.style.transition = '';
              li.removeEventListener('transitionend', handler);
            });
          } else {
            // Open submenu
            li.classList.add('open');
            li.style.height = '10px'; // closed height starting point

            // Wait a frame to ensure height is applied
            requestAnimationFrame(() => {
              const fullHeight = li.scrollHeight;
              li.style.transition = 'height 0.3s ease';
              li.style.height = fullHeight + 'px';
            });

            li.addEventListener('transitionend', function handler() {
              li.style.height = 'auto'; // allow natural height after transition
              li.style.transition = '';
              li.removeEventListener('transitionend', handler);
            });
          }
        }
      });
    }
  });

  // Submit search form on Enter key
  const searchInput = document.getElementById('drawer-search-input');
  const searchForm = document.getElementById('drawer-search-form');

  if (searchInput && searchForm) {
    searchInput.addEventListener('keypress', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        searchForm.submit();
      }
    });
  }
});


  
 